import Navbar from "./components/Navbar/Navbar";
import "wowjs/css/libs/animate.css";
import Favicon from "react-favicon";
import logo from "../src/until/favicon-logo-removebg-preview.png";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import NotFound from "./components/NotFound/NotFound";
import About from "./components/About/About";
import HomePage from "./components/HomePage/HomePage";
import People from './components/People/People'
import Partnerships from "./components/Partnerships/Partnerships";
import History from "./components/History/History";
import ThirdBYID from "./components/ThirdSection/ThirdBYID";
import Louco from './components/Louco/Louco'
import Shishatabak from './components/Shishatabak/Shishatabak'
import Novus from './components/Novus/Novus';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy'
import EnergysabalData from './components/Energysabal/EnergysabalData'
import Terms from './components/Terms/Terms'
function App() {
  const faviconUrl = logo;
  return (
    <>
      <BrowserRouter>
        <Favicon url={faviconUrl} />
        <Navbar />
        <Routes>
        <Route exact path="/:value?" element={<HomePage />} />
        <Route exact path="/people" element={<People />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path='/history' element={<History/>}/>
          <Route exact path='/uniapp' element={<ThirdBYID/>} /> 
          <Route exact path="/partnerships" element={<Partnerships />} />
          <Route exact path='/louco' element={<Louco/>}/>
          <Route exact path='/shishatabak' element={<Shishatabak/>}/>
          <Route exact path='/novus' element={<Novus/>}/>
          <Route exact path='/energysabal' element={<EnergysabalData/>}/>
          <Route exact path='/privacyPolicy' element={<PrivacyPolicy/>}/>
          <Route exact path='/termsAndConditions' element={<Terms/>}/>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
